<template>
  <div class="minW1060-auto bg-fff mag10 pad10">
    <el-row class="text-left">
    <!--  <div class="dlblock-mb20 mr10">
        <span class="pr5">首次授权登录日期</span>
        <el-date-picker
            v-model="date"
            style="width: 300px;"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"/>
      </div> -->
    <!--  <div class="dlblock-mb20 mr10">
        <span class="pr5">状态</span>
        <el-select v-model="status" class="w150" clearable>
          <el-option label="正常" value="NONPROHIBITED"/>
          <el-option label="禁用" value="PROHIBIT"/>
        </el-select>
      </div> -->
    <!--  <div class="dlblock-mb20 mr10">
        <span class="pr5">城市信息</span>
        <el-cascader
            class="w150"
            clearable
            v-model="city"
            :options="cityList"
            :props="{label: 'name', value: 'code'}"
        />
      </div> -->
     <!-- <div class="dlblock-mb20 mr10">
        <span class="pr5">所属代理商</span>
        <el-select v-model="agent" class="w150" clearable>
          <el-option v-for="(item, index) in agentList" :key="index" :label="item.agentName"
                     :value="item.userId"/>
        </el-select>
      </div> -->
    <!--  <div class="dlblock-mb20 mr10">
        <span class="pr5">用户名</span>
        <el-input v-model.trim="name" placeholder="请输入" style="width: 150px;"/>
      </div> -->
      <div class="dlblock-mb20 mr10">
        <span class="pr5">手机号</span>
        <el-input v-model.trim="phone" placeholder="请输入" style="width: 150px;"/>
      </div>
      <div class="dlblock-mb20 mr10">
        <el-button type="primary" @click="pages.page = 1; getUserPageFn()">
          搜索
        </el-button>
      </div>
     <!-- <div class="dlblock-mb20 mr10">
        <el-button type="primary" @click="editBtn(1)">
          邀请好友设置
        </el-button>
      </div> -->
     <!-- <div class="dlblock-mb20">
        <el-button type="primary" @click="editBtn(2)">
          新用户奖励
        </el-button>
      </div> -->
    </el-row>

    <el-table class="my-table" :data="tableData" v-loading="tableLoading" :header-row-class-name="'my-table-header'">
      <el-table-column align="center" prop="account" label="账号"></el-table-column>
      <el-table-column align="center" prop="phone" label="手机号"></el-table-column>
      <el-table-column align="center" prop="createTime" label="创建时间"></el-table-column>
     <!-- <el-table-column align="center" prop="openFlag" label="状态"></el-table-column> -->
      <el-table-column align="center" width="200" label="操作">
        <template slot-scope="{row}">
        <!--  <a class="glob-a" @click="statusBtn(3, row)">查看</a> -->
        <!--  <a class="glob-a" @click="statusBtn(1, row)">{{row.openFlagValue === 'NONPROHIBITED' ? '禁用': '启用'}}</a> -->
          <a class="glob-a" @click="statusBtn(2, row)">角色分配</a>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination background layout="total, prev, pager, next" :total="pages.total"
                     :current-page="pages.page" @current-change="pageChange">
      </el-pagination>
    </div>

    <!-- 账号状态设置 -->
    <el-dialog title="账号状态设置" :visible.sync="statusData.modal" width="550px">
      <el-form :model="statusData" label-width="120px">
        <el-form-item label="当前账号状态:">
          {{statusData.typeName}}
        </el-form-item>
        <el-form-item :label="statusData.type === 'PROHIBIT' ? '启用时间' : '禁用时间:'">
          <el-date-picker
              v-model="statusData.date"
              style="width: 300px;"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
          />
        </el-form-item>
        <el-form-item label="禁用说明:" v-if="statusData.type === 'NONPROHIBITED'">
          <el-input
              type="textarea"
              :rows="5"
              style="width: 300px;"
              maxlength="100"
              resize="none"
              v-model="statusData.content"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="statusData.modal = false">取 消</el-button>
        <el-button type="primary" @click="statusSave">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 角色列表 -->
    <el-dialog title="角色列表" :visible.sync="adData.modal" width="300px">
      <el-row>	
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
          <div style="margin: 15px 0;"></div>
          <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange" >
            <el-checkbox v-for="city in cities" 
			:label="city.id" 
			:v-model="city.id" 
			:key="city.id"> {{city.name}} </el-checkbox>
          </el-checkbox-group>
      </el-row>

      <div slot="footer">
        <el-button @click="adData.modal = false">取 消</el-button>
        <el-button type="primary" @click="adSave">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 详情 -->
    <el-dialog title="查看" :visible.sync="detailModal" fullscreen>
      <detail :id="detailId"/>
    </el-dialog>

    <!-- 邀请好友设置 -->
    <el-dialog title="邀请好友设置" :visible.sync="friendData.modal" width="500px">
      <el-form label-width="120px">
        <el-form-item label="邀请人分成比例">
          <el-input v-model.trim="friendData.ratio" type="number" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="邀请规则">
          <el-input v-model.trim="friendData.content" type="textarea" :rows="5" resize="none" placeholder="请输入"/>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="friendData.modal = false">取 消</el-button>
        <el-button type="primary" @click="editSave(1)">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 新用户奖励 -->
    <el-dialog title="新用户奖励" :visible.sync="newUserData.modal" width="400px">
      <el-form label-width="150px">
        <el-form-item label="奖励购物金金额">
          <el-input v-model.trim="newUserData.value" type="number" placeholder="请输入"/>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="newUserData.modal = false">取 消</el-button>
        <el-button type="primary" @click="editSave(2)">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Detail from './Detail.vue'
  import {
    getUserPage,
    getAgentTree,
    getAreaTreeOnlyCityProvince,
    setUserStatus,
    getUserFriend,
    setUserFriend,
    getUserNewUserRule,
    setUserNewUserRule,
    getUserAdAuth,
    setUserAdAuth,
	
	//查看用户 拥有角色
	getUserRoleList
  } from '@/api'

  export default {
    name: 'UserList',
    components: {Detail},
    data () {
      return {
        date: [],
        status: '',
        city: [],
        cityList: [],
        agent: '',
        agentList: [],
        name: '',
        phone: '',
        tableData: [],
        tableLoading: false,
        pages: {
          page: 1,
          total: 0
        },
        // 详情
        detailId: '',
        detailModal: false,
        // 状态
        statusData: {
          modal: false,
          userId: '',
          type: '',
          typeName: '',
          date: [],
          content: ''
        },
        // 广告权限
        adData: {
          modal: false,
          userId: '',
          adTypeAll: false,
          adType: [],
          adTypeIsIndeterminate: false,
          adPositionAll: false,
          adPosition: [],
          adPositionIsIndeterminate: false,
        },
        adTypeList: [],
        adPositionList: [],
        // 邀请好友设置
        friendData: {
          modal: false,
          ratio: '',
          content: ''
        },
        // 新用户奖励
        newUserData: {
          modal: false,
          value: ''
        },
	
				checkAll: false,
		        checkedCities: ['上海', '北京'],
		        cities: ["上海","北京","南京","天津"],
		        isIndeterminate: true
      }
    },
    created () {
      this.getUserPageFn()
      //this.getAgentTreeFn()
      //this.getAreaTreeOnlyCityProvinceFn()
    },
    methods: {
	  //保存分配角色
      adSave(){
		  var arrayc = new Array()
		   for(var i=0; i< this.cities.length; i++){
		  		arrayc.push(this.cities[i].id);
		  }
        this.adData.modal = false
        setUserAdAuth({
          userId: this.adData.userId,
          checkedCities: this.checkedCities,
		  cities: arrayc
        }).then(res => {
          this.$message.success(res.data)
          this.adData.modal = false
          this.getUserPageFn()
        })
      },
      adTypeAllChange (val, t) {
          this.adData.adType = val ? this.adTypeList.map(item => item.value) : []
          this.adData.adTypeIsIndeterminate = false
      },
      adTypeChange(value, t) {
          let checkedCount = value.length
          this.adData.adTypeAll = checkedCount === this.adTypeList.length
          this.adData.adTypeIsIndeterminate = checkedCount > 0 && checkedCount < this.adTypeList.length
      },
      editSave (t) {
        switch (t) {
          case 1:
            setUserFriend({
              proportion: this.friendData.ratio,
              ruleDescription: this.friendData.content,
            }).then(res => {
              this.$message.success(res.data)
              this.friendData.modal = false
            })
            break
          case 2:
            setUserNewUserRule(this.newUserData.value).then(res => {
              this.$message.success(res.data)
              this.newUserData.modal = false
            })
            break
        }
      },
      // t: 1邀请好友设置 2新用户奖励
      editBtn (t) {
        switch (t) {
          case 1:
            getUserFriend().then(res => {
              this.friendData = {
                modal: true,
                ratio: res.data.propertyValue,
                content: res.data.propertyDesc
              }
            })
            break
          case 2:
            getUserNewUserRule().then(res => {
              this.newUserData = {
                modal: true,
                value: res.data
              }
            })
            break
        }
      },
      statusSave () {
        setUserStatus({
          userId: this.statusData.userId,
          openFlag: this.statusData.type === 'NONPROHIBITED' ? 'PROHIBIT' : 'NONPROHIBITED',
          frozenStartTime: this.statusData.date && this.statusData.date.length ? this.statusData.date[0] : '',
          frozenExpiryTime: this.statusData.date && this.statusData.date.length > 1 ? this.statusData.date[1] : '',
          frozenReason: this.statusData.content,
        }).then(res => {
          this.$message.success(res.data)
          this.statusData.modal = false
          this.getUserPageFn()
        })
      },
      // t: 1切换状态 2广告权限 3查看
      statusBtn (t, row) {
        if (t == 1) {
          this.statusData = {
            modal: true,
            userId: row.userId,
            type: row.openFlagValue,
            typeName: row.openFlag,
            date: [],
            content: ''
          }
        } else if (t == 2) {
          getUserRoleList({userId:row.id}).then(res => {
            this.adData.modal = true
			this.cities = res.data
			var arrayc = new Array()
			 for(var i=0; i< res.data.length; i++){
				if(res.data[i].delFlag === 'N'){
					arrayc.push(res.data[i].id);
				}
			} 
			
			console.info(arrayc,"=========arrayc")
			this.adData.userId = row.id
			this.checkedCities = arrayc
			console.info(this.cities,"=========cities")
			
			
            //this.adData.adPosition = res.data

            //this.adTypeChange(res.data.adType, 1)
            //this.adTypeChange(res.data.adPosition, 2)
          })
        } else {
          this.detailModal = true
          this.detailId = row.userId
        }
      },
      getUserPageFn(){
        this.tableLoading = true
        getUserPage({
          pageNum: this.pages.page,
          content: this.word,
          nickName: this.name,
          cityCode: this.city.length ? this.city[this.city.length - 1] : '',
          superAgentId: this.agent,
          phone: this.phone,
          openFlag: this.status,
          startTime: this.date && this.date.length ? this.date[0] : '',
          endTime: this.date && this.date.length > 1 ? this.date[1] : '',
        }).then(res => {
          this.tableData = res.data.records
          this.pages.total = res.data.total
        }).finally(() => {
          this.tableLoading = false
        })
      },
      pageChange(val){
        this.pages.page = val
        this.getUserPageFn()
      },
      getAgentTreeFn(){
        getAgentTree().then(res => {
          this.agentList = res.data
        })
      },
      getAreaTreeOnlyCityProvinceFn(){
        getAreaTreeOnlyCityProvince().then(res => {
          this.cityList = res.data
        })
      },
	   handleCheckAllChange(val){
	          this.checkedCities = val ? cityOptions : [];
	          this.isIndeterminate = false;
	        },
	   handleCheckedCitiesChange(value){
	          let checkedCount = value.length;
	          this.checkAll = checkedCount === this.cities.length;
	          this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
	    }
    }
  }
</script>

<style scoped>

</style>
